import { PrescreenStatusFilter } from 'api/positions/getAllPositions'

export const prescreenStatuses: {
  label: string
  value: PrescreenStatusFilter
}[] = [
  { label: 'All', value: 'all' },
  { label: 'Prescreened', value: 'prescreened' },
  { label: 'Not Prescreened', value: 'not-prescreened' },
]
